module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookshelf-ee488741.svg";